import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import {
  Form,
  FormGroup,
  Input,
  Button,
  Select,
  ModalView,
  Dropzone,
  Popper,
  LoadingIndicator
} from "../../simple";
import SVG from "../../SVG";
import CountrySelect from "../../complex/CountrySelect";
import {
  validate as validator,
  validationRules
} from "../../../helpers/validate";
import fileIcon from "../../../assets/images/file.png";
import "./styles.scss";

function validate(value) {
  const result = validator(value, validationRules.exist);
  return result;
}

export default class AudienceForm extends React.Component {
  constructor(props) {
    super(props);
    const { client, ...copyData } = props.data;

    this.state = {
      data: {
        ...copyData,
        name:
          // eslint-disable-next-line no-nested-ternary
          this.props.type === "audience_builder"
            ? props?.data?.name?.toLowerCase().indexOf("unnamed") === 0
              ? ""
              : props.data.name
            : "",
        country: props.data?.country?.name || "",
        clientsId: client ? client.id : null
      },
      validation: {
        name: false,
        country: false,
        clientsId: false
      },
      file: null,
      isFilePopper: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileDrop = this.handleFileDrop.bind(this);
    this.handleFilePopperState = this.handleFilePopperState.bind(this);
  }

  handleFileDrop(file) {
    const fileData = new FormData();
    if (file) {
      fileData.append("postal_code_file", file[0]);
      this.setState({ file: fileData });
    }
  }

  handleChange(name, value) {
    this.setState(({ data, validation }) => ({
      data: { ...data, [name]: value },
      validation: {
        ...validation,
        [name]: !validate(value)
      }
    }));
  }

  handleSubmit(evt) {
    const { data, file } = this.state;
    const { handleSubmit } = this.props;
    evt.preventDefault();
    return handleSubmit(data, file);
  }

  handleFilePopperState(state) {
    return this.setState({
      isFilePopper: state
    });
  }

  render() {
    const {
      data: { name, clientsId, country },
      validation,
      isFilePopper,
      file
    } = this.state;
    const {
      data,
      clients,
      withFileUpload,
      countries,
      canChangeClient,
      type,
      isAttachFileLoading,
      isLoadingPresets,
      customerAnalysisError,
      modalTitle
    } = this.props;

    const clientsList = [...clients];

    let isSubmitDisabled;
    if (type === "audience_builder") isSubmitDisabled = false;
    else if ((!!name && validation.name) || !country || !file || !clientsId) {
      isSubmitDisabled = true;
    } else isSubmitDisabled = false;

    let title;
    if (modalTitle && type !== "audiences") title = modalTitle;
    else
      title = type === "audience_builder" ? "Save Audience" : "Create Audience";

    const descriptionText = "";

    const countriesData = countries.map(countryItem => ({
      label: countryItem.name,
      value: countryItem.name,
      code: countryItem.code
    }));

    const selectedClient = clientsList.find(c => c.id === clientsId);

    if (type === "audiences" && !Object.keys(data).length) {
      return (
        <Form onSubmit={this.handleSubmit} className="audience-form">
          <h2 className="title">{title}</h2>
          <span className="description">{descriptionText}</span>
          <FormGroup>
            <CountrySelect
              isDisabled={data?.country}
              name="country"
              countries={countriesData}
              handleChange={this.handleChange}
              value={country}
            />
          </FormGroup>
          {isLoadingPresets ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <LoadingIndicator />
            </div>
          ) : (
            <Button type="submit" className="button" disabled={!country}>
              Save
              <SVG.Arrow className="icon" />
            </Button>
          )}
        </Form>
      );
    }

    return (
      <Form onSubmit={this.handleSubmit} className="audience-form">
        <h2 className="title">{title}</h2>
        <span className="description">{descriptionText}</span>
        <FormGroup>
          <Input
            type="text"
            value={name}
            label="Name"
            name="name"
            placeholder="Name"
            invalid={customerAnalysisError || validation.name}
            handleChange={this.handleChange}
            required
            // fieldError="Please, provide a valid name"
            fieldError={
              customerAnalysisError
                ? "Audience with this name is already exists"
                : "Please, provide a valid name"
            }
          />
          {type === "audience_builder" ? null : (
            <CountrySelect
              isDisabled={data?.country}
              name="country"
              countries={countriesData}
              handleChange={this.handleChange}
              value={country}
            />
          )}
          <Select
            value={
              selectedClient
                ? { value: selectedClient.id, label: selectedClient.name }
                : ""
            }
            label="Client"
            placeholder="Client"
            optionLabel="name"
            optionValue="id"
            options={clientsList}
            name="clientsId"
            handleChange={this.handleChange}
            isDisabled={!canChangeClient}
            required
          />
          {withFileUpload && (
            <>
              <div
                id="dropzone"
                // onFocus={this.handleFilePopperState(true)}}
                // onBlur={this.handleFilePopperState(false)}
                onMouseEnter={() => {
                  this.handleFilePopperState(true);
                }}
                onMouseLeave={() => {
                  this.handleFilePopperState(false);
                }}
              >
                <Dropzone
                  accept=".xlsx, .xls, .csv"
                  onDrop={this.handleFileDrop}
                />
              </div>
              <Popper
                popperOptions={{
                  target: "dropzone",
                  isOpen: isFilePopper,
                  toggle: this.handleFilePopperState
                }}
              >
                <div className="dropzone">
                  <div className="dropzone-formats">
                    <div className="format">
                      <img src={fileIcon} alt="text-file" />
                      <span>.Excel</span>
                    </div>
                    <span className="or">or</span>
                    <div className="format">
                      <img src={fileIcon} alt="text-file" />
                      <span>.csv</span>
                    </div>
                  </div>
                  <div className="dropzone-message">
                    <span>
                      The file should be a CSV file (comma separated file) or an
                      Excel file with a zip code in the first column.
                    </span>
                  </div>
                </div>
              </Popper>
            </>
          )}
        </FormGroup>
        {isAttachFileLoading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <LoadingIndicator />
          </div>
        ) : (
          <Button type="submit" className="button" disabled={isSubmitDisabled}>
            Save
            <SVG.Arrow className="icon" />
          </Button>
        )}
      </Form>
    );
  }
}

AudienceForm.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    client: PropTypes.shape({
      id: PropTypes.string
    }),
    country: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({})),
  withFileUpload: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  canChangeClient: PropTypes.bool,
  type: PropTypes.string,
  isAttachFileLoading: PropTypes.bool.isRequired,
  isLoadingPresets: PropTypes.bool.isRequired,
  customerAnalysisError: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired
};

AudienceForm.defaultProps = {
  countries: [],
  data: {},
  canChangeClient: false,
  type: ""
};

function ModalAudienceForm(props) {
  const {
    modalTitle,
    changeModalState,
    isOpen,
    clients,
    countries,
    data,
    handleSubmit,
    withFileUpload,
    canChangeClient,
    type,
    isAttachFileLoading,
    isLoadingPresets,
    customerAnalysisError,
    ...restProps
  } = props;
  return (
    <ModalView
      toggle={changeModalState}
      handleClose={changeModalState}
      isOpen={isOpen}
      {...restProps}
    >
      <AudienceForm
        customerAnalysisError={customerAnalysisError}
        canChangeClient
        withFileUpload={withFileUpload}
        data={data}
        clients={clients}
        countries={countries}
        handleSubmit={handleSubmit}
        type={type}
        modalTitle={modalTitle}
        isAttachFileLoading={isAttachFileLoading}
        isLoadingPresets={isLoadingPresets}
      />
    </ModalView>
  );
}

ModalAudienceForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  withFileUpload: PropTypes.bool,
  data: PropTypes.shape({}).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({})),
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  changeModalState: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  canChangeClient: PropTypes.bool,
  type: PropTypes.string,
  isAttachFileLoading: PropTypes.bool.isRequired,
  isLoadingPresets: PropTypes.bool.isRequired,
  customerAnalysisError: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired
};

ModalAudienceForm.defaultProps = {
  countries: [],
  withFileUpload: false,
  canChangeClient: true,
  type: ""
};

const mapStateToProps = ({ audiences }) => ({
  isAttachFileLoading: audiences.isAttachFileLoading,
  isLoadingPresets: audiences.isLoadingPresets
});

const connectedModalAudienceForm = connect(
  mapStateToProps,
  null
)(ModalAudienceForm);

export { connectedModalAudienceForm as ModalAudienceForm };
